import SpinnerImage from './SpinnerImage';

export default SpinnerImage;



// WEBPACK FOOTER //
// ./src/components/common/SpinnerImage/index.js